import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svgIcon-cancel",
  "use": "svgIcon-cancel-usage",
  "viewBox": "0 0 41.756 41.756",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 41.756 41.756\" id=\"svgIcon-cancel\"><path d=\"M27.9 20.9L40.2 8.6c2-2 2-5.1 0-7-2-2-5.1-2-7 0L20.9 13.9 8.6 1.6c-2-2-5.1-2-7 0-2 2-2 5.1 0 7l12.3 12.3L1.6 33.2c-2 2-2 5.1 0 7 1 1 2.3 1.5 3.5 1.5 1.3 0 2.6-.5 3.5-1.5l12.3-12.3 12.3 12.3c1 1 2.3 1.5 3.5 1.5s2.6-.5 3.5-1.5c2-2 2-5.1 0-7L27.9 20.9\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol